module.exports = __webpack_public_path__ + "img/obat.650159d6.png";